module.exports = __webpack_public_path__ + "static/media/GT13_GT_Room-Locations.04b02f47.csv";